import { FiltersProvider } from './context/filters.context';
import { StatisticsView } from './statistics.view';

export const StatisticsController = (): React.JSX.Element => {
  return (
    <FiltersProvider>
      <StatisticsView />
    </FiltersProvider>
  );
};
